import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'La familia es la clasificación mayor del repuesto: "Filtros", "Neumáticos", "Correas", "Rodamientos".',
    'Definí las familias antes de cargar repuestos: es el primer nivel de búsqueda en el almacén.',
    'Evitá familias demasiado amplias como "Varios": dificultan encontrar el repuesto después.',
  ],
  nextSteps: [
    'Crear las subfamilias dentro de cada familia para afinar la clasificación.',
    'Asignar familia y subfamilia a cada repuesto del catálogo.',
  ],
};

const ConfiguracionFamiliasRepuesto = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="familias-repuesto"
      titulo="Familias de Repuesto"
      descripcion="Clasificación de repuestos"
      icon="fas fa-boxes"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionFamiliasRepuesto;
